import { type ConsentOrigin, parseConsentOrigin } from "./SetupContext.tsx";

const ORIGIN_PARAM = "origin";
const RETURN_TO_PARAM = "returnTo";

export function buildSetupRedirectUrl(setupPath: string, origin: ConsentOrigin, returnTo: string): string {
    const url = new URL(setupPath, window.location.origin);

    url.searchParams.set(ORIGIN_PARAM, origin);
    url.searchParams.set(RETURN_TO_PARAM, returnTo);

    return `${url.pathname}${url.search}`;
}

export interface SetupRedirectParams {
    origin: ConsentOrigin | null;
    returnTo: string | null;
}

export function parseSetupRedirectParams(searchParams: URLSearchParams): SetupRedirectParams {
    return {
        origin: parseConsentOrigin(searchParams.get(ORIGIN_PARAM)),
        returnTo: searchParams.get(RETURN_TO_PARAM)
    };
}
